const dropzone = require('../components/dropzone');
const clientSideValidation = require('../components/clientSideValidation');
const formUtils = require('../common/utils/formUtils');
const formValidation = require('../components/formValidation');
const { forEachElement } = require('../common/utils/dom');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');

const analyticsEventBus = getAnalyticsEventBus();

const FORM_CONTAINER = '.contact-us__email';
const FORM_SELECTOR = '.contact-form.form';
const CHAT_OPEN_BUTTON = '.chat-button';
const WHATSAPP_LINK = '.whatsapp-button';
const FORM_OPEN_BUTTON = '.email-button';

let formContainer;
let form;
let chatOpenButton;
let whatsappLink;
let formOpenButton;

/**
 * Display the returned error message.
 * @param {string} data - data returned from the server's ajax call
 * @param {jQuery} $button - button that was clicked for contact us sign-up
 */
function displayErrorMessage(data, $button) {
  if (!form) return;

  formValidation(form, {
    fields: data.fields,
  });

  if (data.msg) {
    const errorMsgClass = 'contact-signup-message';
    const errorMsgEle =
      form.querySelector(`.${errorMsgClass}`) || document.createElement('p');
    errorMsgEle.classList.add(errorMsgClass, 'form-invalid-feedback');
    errorMsgEle.textContent = data.msg;
    form.appendChild(errorMsgEle);

    setTimeout(() => {
      errorMsgEle.remove();
      formUtils.enableButton($button);
    }, 3000);
  }
}

function validateBusinessData() {
  // Form business logic validation
  let isValid = true;
  // email validation
  const email = form.querySelector('#contact-email');
  const confirmEmail = form.querySelector('#contact-confirm-email');
  if (email.value !== confirmEmail.value) {
    const errorMessage = confirmEmail.getAttribute(
      'data-repeat-mismatch-error'
    );
    form.querySelector('#form-contact-confirm-email-error').innerText =
      errorMessage;
    isValid = false;
  }

  const selectedRadioValue = form.querySelector(
    'input[type="radio"]:checked'
  )?.value;
  if (selectedRadioValue) {
    // contact topic validation
    const topicSelect = form.querySelector(
      `#contact-topic-${selectedRadioValue}`
    );
    if (topicSelect && topicSelect.classList?.contains('is-empty')) {
      topicSelect.classList.add('is-invalid');
      topicSelect.nextElementSibling.innerText =
        topicSelect.dataset.missingError;
      isValid = false;
    }
  }

  const comment = form.querySelector('#contact-comment');
  if (comment.value === '' || comment.classList.contains('is-empty')) {
    comment.classList.add('is-invalid');
    comment.nextElementSibling.innerText = comment.dataset.missingError;
    isValid = false;
  }

  // initially hidden fields validation
  const dependantFields = document.querySelectorAll(
    '.contact__field--dependant'
  );
  for (let i = 0; i < dependantFields.length; i++) {
    const input = dependantFields[i].querySelector('.input');
    if (input.offsetParent !== null && input.value === '') {
      const errorField = dependantFields[i].querySelector('.invalid-feedback');
      input.classList.add('is-invalid');
      // errorField.classList.add('transition-ap8--show');
      errorField.innerText = input.dataset.missingError;
      /* Timeout to prevent overlapping between two max-height transitions */
      /*
      setTimeout(() => {
        $('body').trigger('transition-m2', [dependantFields[i], true]);
      }, 100);
      */
      isValid = false;
    }
  }

  if (!isValid) {
    return false;
  }

  // At this point all validations passed but need recaptcha to let us go through.
  // CASE 2: If we don't have a recaptcha response value yet in the hidden field,
  // we will need to execute it and wait for a response.
  // CASE 1: The callback defined in the isml will submit the form again when gets response,
  // which will run this same function again, this time returning true below.

  // CASE 1 Callback returned, added value to hiddenRecaptcha and triggered submit again
  if (document.querySelector('.hiddenRecaptcha').value !== '') {
    return true;
  }

  // CASE 2 Callback not returned, execute and stop for submission now:
  grecaptcha.execute();
  return false;
}

/**
 * Shows the chat.
 */
function showChat() {
  const event = new CustomEvent('init-bootstrap-chat', { detail: 'Contacto' });
  document.dispatchEvent(event);
}

/**
 * Fires whatsapp event for analytics.
 */
function handleWhatsappClick() {
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.whatsappOpened,
    'Contacto'
  );
}

/**
 * Shows email contact form.
 */
function showEmailContactForm() {
  formContainer.classList.remove('d-none');
  clientSideValidation.handleSubmitState(form);
  analyticsEventBus.publish(analyticsEventBus.EVENTS.contactFormOpened);
}

/**
 * Validate contact form before submit
 * @param {event} e Event Object
 */
function checksBeforeSubmit(e) {
  e.preventDefault();

  const $submitButton = $('button[type="submit"]', form);
  // check if submit button is disabled
  const isDisabled = formUtils.isButtonDisabled($submitButton);
  if (isDisabled) {
    return;
  }
  formUtils.disableButtonTemporarily($submitButton);

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateBusinessData();

    if (isBusinessValid) {
      doSubmit();
    }
  }
}

function resetForm() {
  $('.subscribe-contact').prop('disabled', false);

  // Clean the form after it has been sent
  // This will trigger the EVENT_FORM_CONTROL_CHANGE on cssBlankPseudo.js,
  // which will make the labels reposition as in new form
  form.reset();

  // Trigger change on checked radioInputs, to show correct related fields after reset
  const radioInputs = form.querySelectorAll('input[type="radio"]:checked');
  forEachElement(radioInputs, (radioInput) => {
    radioInput.dispatchEvent(new Event('change'));
  });
}

function subscribeSuccess() {
  const button = document.querySelector(
    '.subscribe-contact.interaction--swap-text'
  );
  $('body').trigger('interaction--swap-text-event', button);
  resetForm();
}

async function showHideFieldsByTopic(e) {
  const optionSelected = e.target.querySelector('option:checked')?.dataset?.rel;

  if (!optionSelected || !['#sku', '#order-id'].includes(optionSelected)) {
    form.querySelector('.field-text--order-id').style.display = 'none';
    form.querySelector('.field-text--sku').style.display = 'none';
    return;
  }

  const fieldHideSelector = `.field-text--${optionSelected === '#sku' ? 'order-id' : 'sku'}`;
  const fieldHide = form.querySelector(fieldHideSelector);
  fieldHide.style.display = 'none';

  const fieldSelector = `.field-text--${optionSelected.replace(/^#/g, '')}`;
  const field = form.querySelector(fieldSelector);
  field.removeAttribute('style');
}

/**
 * Submit Contact Us Form
 */
function doSubmit() {
  const button = form.querySelector('button[type="submit"]');
  const url = form.getAttribute('action');

  button.setAttribute('disabled', true);

  if (dropzone.methods.processFiles()) {
    return;
  }

  const formData = new FormData(form);
  fetch(url, {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        displayErrorMessage(data, $(button));
      } else {
        subscribeSuccess();
      }
    })
    .catch((err) => {
      displayErrorMessage(err, $(button));
    })
    .finally(() => {
      grecaptcha.reset();
    });
}

async function manageRadioChange(e) {
  const topicElementSelector = `.field-select--${e.target.value}`;
  const topicElement = document.querySelector(topicElementSelector);
  const selectField = topicElement.querySelector('select');

  const show = e.target.value;
  const hide = e.target.value === 'online' ? 'store' : 'online';

  const eleTohide = form.querySelector(`.field-select--${hide}`);
  const eleToShow = form.querySelector(`.field-select--${show}`);
  eleTohide.style.display = 'none';
  eleToShow.removeAttribute('style');

  selectField.selectedIndex = 0;
  selectField.value = selectField.firstElementChild.textContent;
  selectField.dispatchEvent(new Event('change'));
}

module.exports = {
  init() {
    formContainer = document.querySelector(FORM_CONTAINER);
    form = document.querySelector(FORM_SELECTOR);
    chatOpenButton = document.querySelector(CHAT_OPEN_BUTTON);
    whatsappLink = document.querySelector(WHATSAPP_LINK);
    formOpenButton = document.querySelector(FORM_OPEN_BUTTON);
  },
  initChatButton() {
    if (chatOpenButton) {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      chatOpenButton.addEventListener('click', showChat);
    }
  },
  initWhatsappLink() {
    if (whatsappLink) {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      whatsappLink.addEventListener('click', handleWhatsappClick);
    }
  },
  listenContactOpen() {
    if (!formContainer || !formOpenButton) return;
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    formOpenButton.addEventListener('click', showEmailContactForm);
  },
  listenContactSubmit() {
    if (!form) return;
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    form.addEventListener('submit', checksBeforeSubmit);
  },
  initPurchaseType() {
    if (!form) return;
    const radioInputs = form.querySelectorAll('input[type="radio"]');
    forEachElement(radioInputs, (radioInput) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      radioInput.addEventListener('change', manageRadioChange);
    });
  },
  initDropzone() {
    if (!form) return;

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.addEventListener('dropzone-success', (event) => {
      const response = event.detail;
      if (response.error) {
        displayErrorMessage(
          response,
          $(form.querySelector('button[type="submit"]'))
        );
      } else {
        subscribeSuccess();
        this.removeAllFiles(true);
      }
      grecaptcha.reset();
    });

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.addEventListener('dropzone-error', () => {
      grecaptcha.reset();
    });

    const contactImageEle = form.querySelector('.contact__image');
    const contactButton = form.querySelector('button[type="submit"]');
    dropzone.init(contactImageEle, contactButton);
  },
  initTopicChange() {
    if (!form) return;
    forEachElement(
      document.querySelectorAll(
        '#contact-topic, #contact-topic-online, #contact-topic-store'
      ),
      (element) => {
        // eslint-disable-next-line listeners/no-missing-remove-event-listener
        element.addEventListener('change', showHideFieldsByTopic);
      }
    );
  },
  initPrefixSelector() {
    require('../components/ds/forms/country-prefix-selector').init();
  },
  initRegionSelector() {
    require('../components/ds/forms/region-selector').init();
  },
};
